export const t1Headers = [
    "S.No",
    "Actual Profession",
    "Visa Profession",
    "Profession Level",
    "Gender",
    "Nationality",
    "Quantity",
    "Salary",
    "Monthly Fee (each) (including NItakat, Admin & SL Service Fee) (SAR)",
    "Total Monthly Charges (SAR)",
];
export const table1Data = [
    {
        actual_profession: 'ELECTRICIAN',
        visa_profession: 'ELECTRICIAN',
        profession_level: '',
        gender: 'MALE',
        nationality: 'INDIA',
        quantity: '2',
        salary: '3000',
        monthly_fee : 'Sum of (Nitakat+Adminfee+SL Service Fee)',
        total_monthly_charge: `Salary (plus) Additions (if any) (plus) Gosi (plus) First Party Monthly Fee`
    },
    {
        actual_profession: 'ELECTRICIAN',
        visa_profession: 'ELECTRICIAN',
        profession_level: '',
        gender: 'MALE',
        nationality: 'INDIA',
        quantity: '2',
        salary: '3000',
        monthly_fee : 'Sum of (Nitakat+Adminfee+SL Service Fee)',
        total_monthly_charge: `Salary (plus) Additions (if any) (plus) Gosi (plus) First Party Monthly Fee`
    },
    {
        actual_profession: 'ELECTRICIAN',
        visa_profession: 'ELECTRICIAN',
        profession_level: '',
        gender: 'MALE',
        nationality: 'INDIA',
        quantity: '2',
        salary: '3000',
        monthly_fee : 'Sum of (Nitakat+Adminfee+SL Service Fee)',
        total_monthly_charge: `Salary (plus) Additions (if any) (plus) Gosi (plus) First Party Monthly Fee`
    }
]

export const t2Headers = [
    "S.No",
    "CLAUSE",
    "FEE (SAR)",	
    "REMARKS"
];

export const t2Data = [
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
    {
        clause: 'VISA FEE',
        fee_sar: '0000',
        remarks: ''
    },
]


export const t3Headers = [
    "S.NO.",
    "PARTICULARS",
    "MUQEEM POINTS DEDUCTION",
    "EQUIVALENT SAR FOR MUQEEM POINTS",
    "TO BE PAID BY"
]
export const t3Data = [
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
    {
        particulars: 'NEW IQAMA ISSUANCE',
        muqeem_points_deduction: '350',
        sar_muqeem_points: '50',
        to_be_paid: 'Kanoo Group'
    },
]

export const t4Headers = [
    "S.NO.",
    "Particulars",
    "Remarks"
]
export const t4Data = [
    {
        particulars: 'contract Period',
        remarks: '24 months, upon expiry auto renewal for same period'
    }
]